<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57.5 33.5h-51a1.5 1.5 0 000 3h3V56H9a1.5 1.5 0 000 3h46a1.5 1.5 0 000-3h-.5V36.5h3a1.5 1.5 0 000-3zm-35.25 3h3.37V56h-3.37zm-2 19.5h-3.37V36.5h3.37zm7.37-19.5H31V56h-3.38zm5.38 0h3.38V56H33zm5.38 0h3.37V56h-3.37zm5.37 0h3.37V56h-3.37zm-32.25 0h3.38V56H11.5zm41 19.5h-3.38V36.5h3.38zM16 18.5h15v12h2v-12h15v12h3V7a2 2 0 00-2-2H15a2 2 0 00-2 2v23.5h3zm32-2H33V8h15zM31 8v8.5H16V8z"/><path d="M37.88 28a1 1 0 100 2h4.24a1 1 0 100-2z"/></svg>